// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__16tQ8","errorLogs":"EditorFooter_errorLogs__194pv"};